import React, { useEffect, useRef, useState } from 'react'
import { DateRangePicker } from 'react-date-range'

import format from 'date-fns/format'
import * as locales from 'react-date-range/dist/locale'

import { CalendarBlank } from '@phosphor-icons/react'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { Input } from '../common/Input'
import { Container } from './styles'

export const DateRangePickerComp = ({ inputId = "default", dateRange, setDateRange }) => {
  // open close
  const [open, setOpen] = useState(false)

  // get the target element to toggle
  const refOne = useRef(null)

  useEffect(() => {
    // event listeners
    document.addEventListener('keydown', hideOnEscape, true)
    document.addEventListener('click', hideOnClickOutside, true)
  }, [])

  // hide dropdown on ESC press
  const hideOnEscape = (e) => {
    // console.log(e.key)
    if (e.key === 'Escape') {
      setOpen(false)
    }
  }

  // Hide dropdown on outside click
  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setOpen(false)
    }
  }

  return (
    <Container>
      <Input.Root>
        <Input.Label title="Data" htmlFor={inputId} fontSize="14px" />
        <Input.Wrapper
          borderColor="#CECECE"
          backgroundColor="#F7F7F7"
          outlineColor=""
        >
          <Input.Content
            id={inputId}
            padding="0.7rem 0.7rem"
            type="text"
            value={`${format(dateRange[0].startDate, 'dd/MM/yyyy')} - ${format(
              dateRange[0].endDate,
              'dd/MM/yyyy',
            )}`}
            placeholder="Pesquisar"
            onClick={() => {
              console.log('Input clicked, current open state:', open)
              setOpen((open) => !open)
              console.log('Setting open to:', !open)
            }}
            readOnly
          />
          <Input.Icon>
            <CalendarBlank size={20} />
          </Input.Icon>
        </Input.Wrapper>
      </Input.Root>
      <div ref={refOne}>
        {open && (
          <DateRangePicker
            onChange={(item) => {
              console.log('Calendar onChange:', item)
              setDateRange([item.selection])
            }}
            editableDateInputs={false}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            months={2}
            direction="horizontal"
            className="calendarElement"
            dateDisplayFormat="d/MMM/yyyy"
            locale={locales.pt}
            rangeColors={['#6200EE']}
          />
        )}
      </div>
    </Container>
  )
}
